import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { CompetitionLogoComponent } from '@frontend/sports/competition-logos/feature';
import { TitleIconOptions } from '@frontend/sports/types/components/content';

import { EventCarouselItem } from '../../event-carousel.model';

@Component({
    selector: 'ms-event-detail-card-header',
    imports: [CompetitionLogoComponent],
    templateUrl: './event-detail-card-header.component.html',
    styleUrl: './event-detail-card-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventDetailCardHeaderComponent {
    eventCarouselItem = input.required<EventCarouselItem>();

    isCompetitionLogo = computed(() => this.eventCarouselItem().titleData?.titleIcon === TitleIconOptions.CompetitionLogo);
    headerIcon = computed(() => this.getIconClass());

    private getIconClass(): string {
        switch (this.eventCarouselItem().titleData?.titleIcon) {
            case TitleIconOptions.CompetitionFlag:
                return `icon country-icon c${this.eventCarouselItem().event.region.id}`;

            case TitleIconOptions.SportIcon:
                return `icon sports-${this.eventCarouselItem().event.sport.id}`;

            case TitleIconOptions.CompetitionLogo:
                return `sports-${this.eventCarouselItem().event.sport.id}`;

            default:
                return '';
        }
    }
}
